import { render, staticRenderFns } from "./editShopCommunity.vue?vue&type=template&id=380d2e20"
import script from "./editShopCommunity.vue?vue&type=script&lang=js"
export * from "./editShopCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports